module.exports = __webpack_public_path__ + "img/47400.b41f0cf4.jpg";